import { AnimatePresence, motion } from 'framer-motion'
import React, { useCallback, useEffect, useRef } from 'react'
import { useModal } from '@coachmate/common'

export const Modal = () => {
  const { closeModal, modal } = useModal()
  const modalRef = useRef<HTMLDivElement>(null)

  const handleKeydown = useCallback(({ code }: KeyboardEvent) => {
    if (code !== 'Escape') {
      return
    }

    closeModal()
  }, [])

  const handleClickOutside = useCallback(({ target }: MouseEvent | TouchEvent) => {
    if (!modalRef.current || modalRef.current.contains(target as any)) {
      return
    }

    closeModal()
  }, [])

  useEffect(() => {
    if (modal) {
      document.body.style.overflow = 'hidden'
      window.scroll(0, 0)
      window.addEventListener('keydown', handleKeydown)
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside)
    } else {
      document.body.style.overflow = 'auto'
      window.removeEventListener('keydown', handleKeydown)
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [modal])

  return (
    <AnimatePresence>
      {Boolean(modal) && (
        <div className="flex items-center justify-center absolute top-0 right-0 left-0 bottom-0 p-4 z-modal">
          <motion.div
            className="fixed top-0 bottom-0 left-0 right-0 bg-black opacity-60 z-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.6 }}
          />
          <motion.div
            className="relative bg-ui-900 rounded-lg shadow-xl z-modal"
            initial={{ y: -5, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.2 }}
            exit={{ y: -5, opacity: 0 }}
            ref={modalRef}
          >
            {modal}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}
